import {Pagination} from 'react-admin';

export const MyPagination = (props:any) => (
    <Pagination rowsPerPageOptions={[50, 100, 200]} {...props} />
);

export const PER_PAGE = 50;

